import { useIntl } from 'react-intl'
import styled from 'styled-components'
import NeutralLabel from 'LuxKit/Label/NeutralLabel'
import SolidPlaneIcon from 'LuxKit/Icons/solid/SolidPlaneIcon'
import flightBundleGlossaryMessages from 'i18n/flightBundleGlossaryMessages'

const BundleLabel = styled(NeutralLabel)`
  align-self: flex-start;
`

/**
 * "Hotel & Flight bundle" label for charter-bundle hotels (e.g. Maldives
 * MEL↔MLE direct charter) across trip-planner surfaces. Shown whenever a saved
 * accommodation item carries a charterFlightBundle selection.
 */
function CharterBundleLabel() {
  const intl = useIntl()

  return (
    <BundleLabel startIcon={<SolidPlaneIcon />}>
      {intl.formatMessage(flightBundleGlossaryMessages.hotelAndFlightBundle)}
    </BundleLabel>
  )
}

export default CharterBundleLabel
